import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { TableCell, TableRow } from '@mui/material';

import {
    loadContractDetailsForContractId,
    loadServiceDetailsForContractId
} from '../../../store/directusService';
import { loadParticipantByPtCode } from '../../../store/participantService';
import { capitalize } from '../../../utils/capitalize';

import table from '../../../commonStyles/tables.module.css';
import local from './searchResults.module.css';

const ParticipantTableRow = ({ row, showSensitiveCells }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [isPTRequestSent, setIsPTRequestSent] = useState(false);

    // STORE STATE
    const currentParticipant = useSelector(
        (state) => state.entities.participantService.currentParticipant
    );
    const contractDetailsById = useSelector(
        (state) => state.entities.directusService.contractDetailsById
    );
    const servicesByContractId = useSelector(
        (state) => state.entities.directusService.servicesByContractId
    );

    useEffect(() => {
        if (isPTRequestSent && currentParticipant.ptCode === row.ptCode) {
            if (!(currentParticipant.contractId in contractDetailsById))
                dispatch(loadContractDetailsForContractId(currentParticipant.contractId));
            if (!(currentParticipant.contractId in servicesByContractId))
                dispatch(loadServiceDetailsForContractId(currentParticipant.contractId));
        }
    }, [currentParticipant]);

    useEffect(() => {
        if (
            isPTRequestSent &&
            currentParticipant?.ptCode === row.ptCode &&
            contractDetailsById[currentParticipant.contractId] &&
            servicesByContractId[currentParticipant.contractId]
        )
            navigate('/edit_participant');
    }, [contractDetailsById, servicesByContractId, currentParticipant]);

    // EVENT HANDLERS
    const onClickPTCode = () => {
        if (row?.ptCode) {
            dispatch(loadParticipantByPtCode(row.ptCode));
            setIsPTRequestSent(true);
        }
    };

    return (
        <TableRow
            hover
            className={`${showSensitiveCells ? table.basicRowStripes : table.noStripes}`}>
            <TableCell className={table.rowLink} onClick={onClickPTCode}>
                {row.ptCode}
            </TableCell>
            <TableCell>{capitalize(row.firstName)}</TableCell>
            {showSensitiveCells && (
                <TableCell>
                    {capitalize(row.lastName ?? <span className={local.alignCenter}> - </span>)}
                </TableCell>
            )}
            {showSensitiveCells && (
                <TableCell>
                    {row.postcode?.toUpperCase() ?? <span className={local.alignCenter}> - </span>}
                </TableCell>
            )}
            {showSensitiveCells && <TableCell>{row.uniqueIdentifier?.toUpperCase()}</TableCell>}
            {showSensitiveCells && (
                <TableCell>
                    {row.primaryPhoneNumber ?? <span className={local.alignCenter}> - </span>}
                </TableCell>
            )}
            {showSensitiveCells && (
                <TableCell>
                    {row.emailAddress ?? <span className={local.alignCenter}> - </span>}
                </TableCell>
            )}
        </TableRow>
    );
};

ParticipantTableRow.propTypes = {
    row: PropTypes.object.isRequired,
    showSensitiveCells: PropTypes.bool.isRequired
};

export default ParticipantTableRow;
